<app-pageheader [Parent]="this"></app-pageheader>
@if (charts && charts.length > 0) {
  <div class="message is-light is-small" style="margin-bottom: 1rem;">
    <div class="message-body has-text-grey" style="padding: 0.5rem; font-size: 0.9rem;">
      <span class="icon-text">
        <span class="icon">
          <i class="fas fa-info-circle"></i>
        </span>
        <span>Click on a chart to enter full-page mode for dataset management, or alternatively, hover to view data points</span>
      </span>
    </div>
  </div>
}
@if (charts && charts.length > 0) {
  <div class="columns is-multiline">
    @for (chart of charts; track chart) {
      <div class="column is-6">
        <div style="position: relative;" (click)="openFullPageStats(chart)" style="cursor: pointer;">
          <app-dashboard-chart
            [chartType]="chart.chartType"
            [stacked]="chart.stacked"
            [dataSetRequests]="chart.dataSetRequests"
            [title]="chart.title"
            [ShowFilters]="false"
            [isFullPage]="false"
            [selectedDateRange]="chart.selectedDateRange"
            [GroupBy]="chart.groupBy"
            [bucketSize]="chart.bucketSize"
            [asPercentage]="chart.asPercentage"
            [yAxisLabel]="chart.yAxisLabel">
          </app-dashboard-chart>
        </div>
      </div>
    }
  </div>
}

@if (!charts || charts.length === 0) {
  <div class="has-text-centered p-6">
    <div class="loader"></div>
    <p class="switch-message">
      Please wait while we fetch your default charts
    </p>
  </div>
}